// FieldPicker.jsx — field dropdown grouped by category, with help popover per option
import React from 'react';
import Select, { components } from 'react-select';
import { fieldsByCategory, getField } from '../helpers/fieldCatalog.js';
import HelpPopover from './HelpPopover.jsx';

// Renders the label + help icon in the dropdown list AND in the selected value area.
const OptionWithHelp = (props) => {
  const field = props.data._field;
  return (
    <components.Option {...props}>
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {props.data.label}
        {field && (
          <HelpPopover
            description={field.description}
            example={field.example}
            tips={field.tips}
            placement="right"
          />
        )}
      </span>
    </components.Option>
  );
};

const FieldPicker = ({ value, onChange }) => {
  const groups = fieldsByCategory();
  const options = Object.entries(groups).map(([category, fields]) => ({
    label: category,
    options: fields.map(f => ({ value: f.key, label: f.label, _field: f })),
  }));
  const selected = value
    ? { value, label: getField(value)?.label || value }
    : null;

  return (
    <Select
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : null)}
      options={options}
      placeholder="Select field…"
      classNamePrefix="rs"
      isClearable
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      components={{ Option: OptionWithHelp }}
    />
  );
};

export default FieldPicker;
